import * as React from "react";
import { GeneralContext } from "../../core/general.context";
import { CartProduct } from "./cart.product.component";
import { CartRecap } from "./cart.recap.component";
import { LabelContext } from "../../core/label.context";
import { PROJECT_LANGUAGE, PROJECT_SETTINGS } from "../../core/APIUtils";
import { CartContext } from "../../core/cart.context";
import { SliderItems } from "../sliders/slideritems.component";
import {ILineItem} from "../../common/cart.models";

export const Cart = (props: any) => {
  const { t } = React.useContext(LabelContext);
  const { cart } = React.useContext(GeneralContext);
  const { 
    hasServicesInCart,
    recalculate,
  } = React.useContext(CartContext);

  // Utilizzato per i bundle, per evitare di inserire due volte un bundle già inserito
  let bundlesInCart:String[] = []
  React.useEffect(() => {    

    if(cart){
      recalculate(cart);
    }
  }, [])


return <>
      
      <div className="checkout-column-main col-lg-7">
        <div className="wrapper">
          <div style={{ lineHeight: '22px' }} className="focus my-3" dangerouslySetInnerHTML={{ __html: t("ecommerce.cart.messageUnderTitleCart") }} />
          {PROJECT_SETTINGS.showDeliveryInStore &&
            <div className="delivery-compatible">
              <div className="label">
                <span>{hasServicesInCart ? t("ecommerce.checkout.deliveryCompatible.NO") : t("ecommerce.checkout.deliveryCompatible.YES")}</span>
                <button className="ec_btn ec_btn-moreInfo" aria-haspopup="true" data-toggle="collapse" aria-expanded="false" data-target="#delivery-compatible-info">
                  <span className="icon"/>
                  <span className="testo">{t("ecommerce.checkout.moreInfo")}</span>
                </button>
              </div>
              <div className="collapse" id="delivery-compatible-info">
                {hasServicesInCart ? t("ecommerce.checkout.deliveryCompatible.description.NO") : t("ecommerce.checkout.deliveryCompatible.description.YES")}
              </div>
            </div>
          }

          
          <div className="cartProduct-list">
            {cart.lineItems.map((item, i) => {
              const channelId = item?.supplyChannel?.id
              const rawServices = item.variant.attributes.find(attr => attr.name === "related-services")?.value || []
              //filtro i servizi:
              //- se il prodotto é refurbish A prendo solo i servizi con refurbish A (supplyChannel -> channelId)
              //- se il prodotto é refurbish AA prendo solo i servizi con refurbish AA (supplyChannel -> channelId)
              //- se i prodotto é normale prendo tutti i servizi correlati
              const filteredServices =
                  !channelId
                      ? rawServices
                      : rawServices.filter((service: any) => {
                        const channelAvailability =
                            service?.obj?.masterData?.current?.masterVariant?.availability?.channels?.[channelId]

                        return channelAvailability?.availableQuantity > 0
                      })
              let relatedServices = [
                {
                  sku: item.productKey,
                  productId: item.productId,
                  channelId: channelId,
                  value: filteredServices
                }
              ]


              let selectedServices = cart.lineItems.filter((item2: ILineItem) => {
                const productChannelId = item?.supplyChannel?.id
                const serviceChannelId = item2?.supplyChannel?.id

                const isRelated =
                    item2.custom?.fields?.relatedLineItem?.id === item.productId

                // Permette di considerare solo i servizi dello stesso channel del prodotto:
                // - se il prodotto ha un channel → prende solo servizi con lo stesso channel
                // - se non ha channel → prende solo servizi senza channel
                const sameChannel =
                    productChannelId === serviceChannelId

                return isRelated && sameChannel
              })
                let title = item.name[PROJECT_LANGUAGE];
                let displayItem = true
                let bundleKey = ""
                if(item.custom?.fields["lineitem-bundle"]){
                    if(!bundlesInCart.includes(item.custom.fields["lineitem-bundle"])){
                      bundleKey = item.custom.fields["lineitem-bundle"]
                      title = bundleKey
                      bundlesInCart.push(bundleKey)
                      let relatedServicesBundle:any = []
                      // RelatedService per tutti prodotti del bundle
                      cart.lineItems.filter(
                        (_lineItem:any) => _lineItem.custom?.fields?.["lineitem-bundle"] === bundleKey).map(
                          (__lineItem:any) => {
                            let _relatedServicesBundle = __lineItem.variant.attributes.find((attr:any) => attr.name === "related-services")
                            if(_relatedServicesBundle){
                              relatedServicesBundle.push(
                                  {
                                    "sku": __lineItem.productKey,
                                    "productId":__lineItem.productId,
                                    "value": _relatedServicesBundle.value
                                  }
                              )
                            }

                            // Selected Service
                            selectedServices = [
                              ...selectedServices,
                              ...cart.lineItems.filter(item2 => item2.custom?.fields?.relatedLineItem?.id === __lineItem.productId)
                            ]
                          }
                        )
                      relatedServices = relatedServicesBundle
                    }else{
                      displayItem = false
                    }
                }


                if (item.productType.obj?.key === "services" || !displayItem)
                  return ""
                return (
                  <CartProduct
                    item={item}
                    displayItem={displayItem}
                    bundleKey={bundleKey}
                    key={i}
                    ID={item.id}
                    title={title}
                    productID={item.productId}
                    name={item.name[PROJECT_LANGUAGE]}
                    sku={item.variant.sku}
                    imgSrc={item.variant.images[0]?.url}
                    quantity={item.quantity}
                    relatedServices={relatedServices}
                    selectedServices={selectedServices}
                  />
                );
              })
            }
          </div>
        </div>
      </div>
      <aside className="checkout-column-aside col-lg-5">
        <CartRecap isCartPage={true} />
      </aside>
     {props.relatedBundles.length > 0 && cart.lineItems.length > 0 && false &&
        <>
        <h2 className="title text-black mt-5 mb-0">{t("ecommerce.common.relatedBundles.title")}</h2>
        <div className="related-bundle" style={{ width: '100%' }}>
          <SliderItems items={props.relatedBundles} title={t('ecommerce.common.relatedBundles.title')} type={"bundle"} />
        </div>
        </>
      }
    
  </>

};